import { FC, useMemo } from 'react';

import { NON_BREAKING_SPACE, SortType } from 'utils/constants/common';

import Icon, { IconKind, IconScale, IconView } from 'bloko/blocks/icon';

import useTrls from 'hooks/translation/useTrls';

import { useSelector } from 'store/utils';

import 'components/Admin/Reports/ActsReport/ActsTable/Header/LabelSort/LabelSort.less';

interface LabelSortProps {
    column: string;
    disableSorts?: boolean;
    tip?: React.ReactNode;
}

const LabelSort: FC<LabelSortProps> = ({ column, disableSorts, tip }) => {
    const sorts = useSelector((state) => state.acts.sorts);

    const trl = useTrls();

    const direction = useMemo(() => {
        const allSorts = [...sorts];
        const lastSort = allSorts.length > 0 ? allSorts[allSorts.length - 1] : false;
        return lastSort && lastSort[0] === column ? lastSort[1] : '';
    }, [column, sorts]);

    if (disableSorts) {
        return <>{trl(`admin.actsReport.actsTable.header.${column}`)}</>;
    }
    return (
        <div className="label-sort">
            <div className="label-sort__text">
                {trl(`admin.actsReport.actsTable.header.${column}`)}
                {NON_BREAKING_SPACE}
                {direction === SortType.ASC ? (
                    <Icon view={IconView.Chevron} kind={IconKind.Down} scale={IconScale.Small} />
                ) : null}
                {direction === SortType.DESC ? (
                    <Icon view={IconView.Chevron} kind={IconKind.Up} scale={IconScale.Small} />
                ) : null}
            </div>
            <div className="label-sort__tooltip">{tip}</div>
        </div>
    );
};

export default LabelSort;
